"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_UI = 'UPDATE_UI';
exports.CLEAR_UI = 'CLEAR_UI';
/**
 * @param component - unique name or unique object (with name and id, etc) to update
 * @param render - open, close, animate-open, animate-closed, etc...
 * @param showSpinner
 * @param toggle - on/off or true/false part of component
 * @param error - show error on the component
 */
var UI_PARTS = [
    'component',
    'render',
    'showSpinner',
    'toggle',
    'error'
];
/**
 * This action is used to change store for just UI change - rendering, interactions, etc...
 *
 * @returns {{type: string, payload: {}}}
 */
function updateUI(parts) {
    var payload = {};
    // restrict payload to known UI parts only
    UI_PARTS.forEach(function (i) {
        if (parts[i] !== undefined) {
            payload[i] = parts[i];
        }
    });
    return {
        type: exports.UPDATE_UI,
        payload: payload
    };
}
exports.updateUI = updateUI;
function clearUI() {
    return {
        type: exports.CLEAR_UI,
        payload: {}
    };
}
exports.clearUI = clearUI;
